import Vue from 'vue'
import VueRouter from 'vue-router'
import LiveRoutes from './live/'

Vue.use(VueRouter)

let routes = []
routes.push({
  path: '/',
  name: 'index',
  component: () => import(/* webpackChunkName: "main" */ '@/components/index/')

})
routes = routes.concat(LiveRoutes)

export function createRouter () {
  const router = new VueRouter({
    mode: 'history',
    fallback: false,
    scrollBehavior: () => ({ y: 0 }),
    routes
  })

  router.beforeEach((to, from, next) => {
    if (window._hmt && to.fullPath) window._hmt.push(['_trackPageview', to.fullPath])
    next()
  })

  return router
}



// WEBPACK FOOTER //
// ./src/router/index.js